import { render, staticRenderFns } from "./CardsCategories.vue?vue&type=template&id=4866fb6b&scoped=true"
import script from "./CardsCategories.vue?vue&type=script&lang=js"
export * from "./CardsCategories.vue?vue&type=script&lang=js"
import style0 from "./CardsCategories.vue?vue&type=style&index=0&id=4866fb6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4866fb6b",
  null
  
)

export default component.exports